<template>
  <div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
      <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
<br/>
    <!-- Card stats -->
    <b-container fluid class="">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row>
              <!-- Start -->
              <b-container fluid>
                <b-row class="mb-4">
                  <b-col cols="12">
                    <h4 class="text-primary">DASHBOARD</h4>
                  </b-col>
                </b-row>

                <b-row class="justify-content-center">
                  <b-col xl="4" md="5" class="mb-4">
                    <stats-card2
                      title="DALAM TINDAKAN"
                      type="gradient-primary"
                      :sub-title="DashboardPeraku.dalam_tindakan"
                      icon="fa fa-address-card fa-5x"
                      class="border border-primary rounded p-3 shadow-lg"
                      variant="primary"
                    >
                      <template slot="footer">
                        <base-button
                          outline
                          type="primary"
                          class="w-100"
                          @click="divcomDalamTindakan()"
                          >Lihat Senarai</base-button
                        >
                      </template>
                    </stats-card2>
                  </b-col>

                  <b-col xl="4" md="5" class="mb-4">
                    <stats-card2
                      title="SELESAI"
                      type="gradient-info"
                      :sub-title="DashboardPeraku.selesai"
                      icon="fa fa-check-circle fa-5x"
                      class="border border-info rounded p-3 shadow-lg"
                      variant="info"
                    >
                      <template slot="footer">
                        <base-button
                          outline
                          type="info"
                          class="w-100"
                          @click="divcomSelesai()"
                          >Lihat Senarai</base-button
                        >
                      </template>
                    </stats-card2>
                  </b-col>
                </b-row>
              </b-container>
              <!-- End -->
            </b-row>
            <b-row>
              <b-col>&nbsp;</b-col>
            </b-row>
          </card>
        </b-col>
        
        <br /><br /><br />
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-container fluid>
              <div v-if="comdalamTindakan">
                <senaraiPADlmTindakan @refreshDashboard="refreshDashboard" />
              </div>
              <div v-if="comSelesai">
                <senaraiSelesai />
              </div>
            </b-container>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import senaraiSelesai from "@/views/Skg/senaraiSelesai.vue";
import senaraiPADlmTindakan from "@/views/Skg/senaraiPADlmTindakan.vue";
// import Store from "@/store";
import GetsalaryService from "@/services/salaryService.js";
 import StatsCard2 from "@/components/Cards/StatsCard2.vue";
 export default {
   components: {
//     SenaraiPerakuan,
//     // SenaraiTindakanPeraku2,
   senaraiSelesai,
     senaraiPADlmTindakan,
     StatsCard2,
   },
   data() {
    return {
      DashboardPeraku: {},
      comdalamTindakan: false,
      comSelesai: false,
    };
  },

  methods: {
    divcomDalamTindakan() {
      this.comdalamTindakan = true;
      this.comSelesai = false;
    },

    divcomSelesai() {
      this.comdalamTindakan = false;
      this.comSelesai = true;
    },

    getDashboard() {
      GetsalaryService.getDashboard().then((resp) => {
        this.DashboardPeraku = resp.data;
      });
    },
    refreshDashboard() {
      this.getDashboard();
    },
  },

  created() {
    this.getDashboard();

  },


};
</script>

<style scoped>
/* Optional: Customize styles for better aesthetics */
h4 {
  font-weight: 600;
  text-transform: uppercase;
}

.stats-card2 {
  transition: transform 0.3s;
}

.stats-card2:hover {
  transform: scale(1.05); /* Scale up on hover */
}

.base-button {
  transition: background-color 0.3s;
}

.base-button:hover {
  background-color: rgba(255, 255, 255, 0.1); /* Slight change on hover */
}
</style>

